import axios from 'axios'
import Vue from 'vue'
export default {
	namespaced: true,
	state: {
		buscador: {
			galerias: [],
			items: []
		},
		galeria: null,
		cola: [],
		subiendo: null,
		progressId: null,
		colaSubidos: 0
	},
	getters: {
		buscador (state) {
			return state.buscador
		},
		galeria (state) {
			return state.galeria
		}
	},
	mutations: {
		SET_ENCONTRADOS (state, payload) {
			state.buscador.galerias = payload.galerias
			state.buscador.items = payload.items
		},
		ADD_COLA (state, payload) {
			state.cola.push(payload)

			// Hay que procesar la cola
			this.dispatch('galerias/procesarCola')
		},
		VACIA_COLA (state) {
			state.cola = []
		},
		SET_GALERIA (state, payload) {
			state.galeria = payload
		},
		DEL_ITEM (state, ItemID) {
			for (let i = state.galeria.items.length - 1; i >= 0; i--) {
				if (state.galeria.items[i].ItemID === ItemID) {
					state.galeria.items.splice(i, 1)
				}
			}
		},
		SET_ITEM (state, item) {
			for (let i = 0; i < state.galeria.items.length; i++) {
				if (state.galeria.items[i].ItemID === item.ItemID) {
					Vue.set(state.galeria.items, i, item)
				}
			}
		},
		SUMA_SUBIDOS (state) {
			state.colaSubidos = state.colaSubidos + 1
		},
		RESET_SUBIDOS (state) {
			state.colaSubidos = 0
		}
	},
	actions: {
		buscar (context, payload) {
			// PRIMERO BORRAMOS LOS RESULTADOS ANTERIORES
			context.commit('SET_ENCONTRADOS', {galerias: [], items: []})

			// AHORA BUSCAMOS
			axios.post('galerias/php/api/buscador.php', payload)
				.then(res => {
					context.commit('SET_ENCONTRADOS', res.data)
				})
				.catch(e => {
					this.commit('toast/danger', {
						titulo: 'Error',
						mensaje: 'Error en la búsqueda'
					})
				})
		},
		procesarCola (context) {
			if (context.state.subiendo) {
				return
			}
			if (context.state.cola.length > context.state.colaSubidos) {
				if (!context.state.progressId) {
					context.state.progressId = 'progress' + new Date().getTime().toString()

					const progreso = {
						id: context.state.progressId,
						titulo: 'Subida de ficheros',
						mensaje: 'Subiendo ' + (context.state.colaSubidos + 1) + ' de ' + context.state.cola.length + ' ficheros',
						progress: Math.round(context.state.colaSubidos * 100 / context.state.cola.length)
					}

					this.commit('toast/progress', progreso)
				}

				context.state.subiendo = context.state.cola[context.state.colaSubidos]

				const ajax = new XMLHttpRequest()
				ajax.open('POST', 'src/modulos/galerias/php/api/upload.php?GaleriaID=' + context.state.subiendo.GaleriaID)
				ajax.responseType = 'json'
				ajax.onreadystatechange = (ev) => {
					if (ajax.readyState === 4) {
						context.commit('SUMA_SUBIDOS')
						if (ajax.status !== 200) {
							this.commit('toast/danger', {
								titulo: 'Error',
								mensaje: 'Error realizando el upload'
							})
						} else {
							if (context.state.galeria && context.state.galeria.GaleriaID === ajax.response.galeria.GaleriaID) {
								context.commit('SET_GALERIA', ajax.response.galeria)
							}
						}
						const progreso = {
							id: context.state.progressId,
							titulo: 'Subida de ficheros',
							mensaje: 'Subiendo ' + (context.state.colaSubidos + 1) + ' de ' + context.state.cola.length + ' ficheros',
							progress: Math.round(context.state.colaSubidos * 100 / context.state.cola.length)
						}

						this.commit('toast/progress', progreso)
						context.state.subiendo = null
						context.dispatch('procesarCola')
					}
				}

				ajax.upload.onprogress = (ev) => {
					if (ev.lengthComputable) {
						const total = ev.total
						const loaded = ev.loaded
						const porcentaje = Math.round(loaded * 100 / total)

						// Intervalos
						const intervalo = Math.round(100 / context.state.cola.length)
						const progresoPequeno = Math.round(intervalo * porcentaje / 100)

						const progreso = {
							id: context.state.progressId,
							titulo: 'Subida de ficheros',
							mensaje: 'Subiendo ' + (context.state.colaSubidos + 1) + ' de ' + context.state.cola.length + ' ficheros',
							progress: Math.round((context.state.colaSubidos * 100 / context.state.cola.length) + progresoPequeno)
						}

						this.commit('toast/progress', progreso)
					}
				}
				const form = new FormData()
				form.append('fichero[]', context.state.subiendo.fichero)
				ajax.send(form)
			} else {
				if (context.state.progressId) {
					const progreso = {
						id: context.state.progressId,
						titulo: 'Subida de ficheros',
						mensaje: 'Subidos ' + context.state.cola.length + ' ficheros',
						progress: 100,
						closed: true,
						active: false
					}

					this.commit('toast/progress', progreso)

					window.setTimeout(() => {
						console.log('Cerrando')
						this.commit('toast/delete', context.state.progressId)
						context.state.progressId = null
					}, 300)
					context.commit('RESET_SUBIDOS')
					context.commit('VACIA_COLA')
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/galerias/vue/store.js